import { createRoute } from '@tanstack/react-router';
import { lazy, Suspense } from 'react';
import { Route as RootRoute } from './__root';

const PostaForm = lazy(() =>
  import('@/modules/posta/PostaForm').then((m) => ({ default: m.PostaForm })),
);

export const Route = createRoute({
  getParentRoute: () => RootRoute,
  path: '/posta/novy',
  component: () => (
    <Suspense fallback={null}>
      <PostaForm />
    </Suspense>
  ),
});
